import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { IconColor, IconSize } from '../icon/icon.component';

type InputType = 'text' | 'email' | 'search' | 'number';
type InputSize = 'small' | 'mid' | 'large' | 'xlarge' | 'xxlarge';
type BackgroundColor = 'dark' | 'light';

@Component({
  selector: 'fl-input',
  template: `
    <div
      class="InputContainer"
      [ngClass]="{
        NoFill: backgroundColor === 'dark',
        BeforeLabelPresent: beforeLabel.length > 0,
        AfterLabelPresent: afterLabel.length > 0
      }"
      [attr.data-size]="size"
    >
      <div class="InputLabel BeforeLabel"
        *ngIf="beforeLabel.length > 0"
        [attr.data-size]="size"
      >
        <span class="LabelText"> {{ beforeLabel }} </span>
      </div>

      <fl-icon *ngIf="iconStart"
        class="IconStart"
        [size]="leftIconSize"
        [color]="leftIconColor"
        [name]="iconStart"
      ></fl-icon>
      <input #nativeElement
        class="NativeElement"
        [ngClass]="{
          NoFill: backgroundColor === 'dark'
        }"
        [attr.type]="type"
        [attr.placeholder]="placeholder"
        [attr.readonly]="attrReadonly ? true : null"
        [formControl]="control"
      >
      <fl-icon *ngIf="iconEnd"
        class="IconEnd"
        [name]="iconEnd"
      ></fl-icon>

      <div class="InputLabel AfterLabel"
        *ngIf="afterLabel.length > 0"
        [attr.data-size]="size"
      >
        <span class="LabelText"> {{ afterLabel }} </span>
      </div>
    </div>

    <div *ngIf="control.invalid" class="ErrorText">
        {{ error }}
    </div>
  `,
  styleUrls: ['./input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent implements OnInit, OnDestroy {
  error: string;
  errorSubscription: Subscription;

  @Input() attrReadonly?: true;
  @Input() control: FormControl;
  @Input() placeholder: string;
  @Input() size: InputSize = 'mid';
  @Input() type: InputType = 'text';
  @Input() backgroundColor: BackgroundColor = 'light';

  @Input() iconStart: string;
  @Input() iconEnd: string;
  @Input() leftIconSize = IconSize.MID;
  @Input() leftIconColor = IconColor.INHERIT;
  @Input() beforeLabel = '';
  @Input() afterLabel = '';

  @ViewChild('nativeElement') nativeElement: ElementRef;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.errorSubscription = this.control.statusChanges.subscribe(() => {
      [this.error] = Object.values(this.control.errors || {});
      this.cd.markForCheck();
    });
  }

  ngOnDestroy() {
    this.errorSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/ui/input/input.component.ts